export class Course {
    courseId: string;
    courseTitle: string;
    courseCreationDate: string;
  
    constructor(courseId: string, courseTitle: string, courseCreationDate: string) {
      this.courseId = courseId;
      this.courseTitle = courseTitle;
      this.courseCreationDate = courseCreationDate;
    }
  }